
export const calculateStrokeDashoffset = (attendance: number): string => {
    const maxAttendance = 100;
    const circumference = 2 * Math.PI * 24;

    const strokeDashoffset = circumference - (attendance / maxAttendance) * circumference;

    return strokeDashoffset.toFixed(1);
};

